import { render, staticRenderFns } from "./U_VoiceBusiness.vue?vue&type=template&id=6feaa70c&scoped=true&"
import script from "./U_VoiceBusiness.vue?vue&type=script&lang=js&"
export * from "./U_VoiceBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feaa70c",
  null
  
)

export default component.exports